var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16 7.78-5.826 5.826-3.39-3.39L16 1l9.22 9.219-3.39 3.389L16 7.779zM4.39 12.61 1 16l3.39 3.39L7.78 16l-3.39-3.39zM16 24.22l-5.826-5.826-3.395 3.385.004.004L16 31l9.22-9.219-3.391-3.389-5.83 5.83zM27.61 12.61l-3.39 3.391 3.39 3.391L31 16.002l-3.39-3.389zm-8.17 3.387h-.002l.003.002L16 19.44l-3.438-3.437-.004-.005.005-.004.602-.603.292-.29L16 12.556l3.44 3.44z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.82db18f2c8d957bbb9eaf176a2c8e587.svg";
export { ForwardRef as ReactComponent };